<template>
    <div class="border border-50 rounded-lg overflow-hidden" v-if='lastMeasurement'>
        <table class="w-full">
            <tbody>
            <tr>
                <th class="text-left py-3 px-3">{{ $t('Raised at') + ':' }}</th>
                <td class="py-3">{{ $du(lastMeasurement.timestamp, 'shortDateTime') }}</td>
            </tr>
            <tr>
                <th class="text-left py-3 px-3 border-t border-50">{{ $t('Measured value') + ':' }}</th>
                <td class="py-3 border-t border-50">{{ $n(lastMeasurement.value, format) + ' ' + unit }}</td>
            </tr>
            <tr>
                <th class="text-left py-3 px-3 border-t border-50">{{ $t('Last read value') + ':' }}</th>
                <td class="py-3 border-t border-50">
                        <span
                            class="font-semibold"
                            :class="{
                                'text-green': lastMeasurement.inThreshold,
                                'text-red': !lastMeasurement.inThreshold
                            }"
                        >
                            {{ $n(lastMeasurement.value, format) + ' ' + lastMeasurement.unit }}
                        </span>
                    {{ $t('at {date}', { 'date': $du(lastMeasurement.timestamp, 'shortDateTime') }) }}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div v-else>{{ $t('Last measurement unavailable.') }}</div>
</template>

<script>
    export default {
        props: {
            payload: {
                type: Object,
                required: true,
            },
            lastMeasurement: {
                type: Object,
                required: true,
            },
        },
        computed: {
            format() {
                switch (this.payload.metric) {
                    case 'temperature':
                        return 'metricTemperature';
                    case 'humidity':
                        return 'metricHumidity';
                    default:
                        return 'integer';
                }
            },
            unit() {
                switch (this.payload.metric) {
                    case 'temperature':
                        return '°C';
                    case 'humidity':
                        return '%';
                    default:
                        return '';
                }
            },
        },
    };
</script>
